import { SvgIcon, SvgIconProps } from "@mui/material";

export const RightArrowCtaIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      aria-label="righ arrow icon"
    >
      <path
        stroke="#1C1E26"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M19 12H5m9 5 5-5m-5-5 5 5"
      />
    </svg>
    ;
  </SvgIcon>
);
